import styled from "styled-components/macro";
import { Modal, Skeleton } from "@mui/material";
import {
  CheckboxLabelWrapper,
  NewReqRequiredMessage,
} from "../NewRequisition/NewRequisition.styles";

export const CenteredModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  gap: 16px;
  margin-top: 15px;
  padding: 0 24px;
  color: ${({ theme }) => theme.primaryTextColor};
  font-weight: 400;
`;

export const CloseButton = styled.span`
  margin-right: 8px;
`;

export const ModalLoadingBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  gap: 16px;
  margin-top: 15px;
  padding: 0 24px;
`;

export const ModalLoadingText = styled(Skeleton)`
  width: 60%;
  height: 24px;
  border-radius: 4px;
`;

export const ModalLoadingPatientColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ModalLoadingPatientText = styled(Skeleton)`
  width: 140px;
  height: 16px;
  border-radius: 4px;
`;

export const ModalLoadingOption = styled(Skeleton)`
  width: 45%;
  height: 32px;
  border-radius: 4px;
`;

export const ConfirmMessage = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.primaryTextColor};
`;

export const PatientBox = styled.div`
  display: flex;
  gap: 32px;
  padding: 10px;
  background: var(--Neutral-50, #f9f9f9);
`;

export const PatientColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const PatientLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.primaryTextColor};
`;

export const PatientValue = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.primaryTextColor};
`;

export const Disclaimer = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.primaryTextColor};
`;

export const ConfirmCheckboxLabel = styled(CheckboxLabelWrapper)`
  && {
    margin-left: 0;
    .MuiCheckbox-root {
      margin: -9px 5px -9px -9px;
      padding: 9px 0 9px 9px;
    }
    .MuiFormControlLabel-label {
      color: ${({ theme }) => theme.primaryTextColor};
    }
  }
`;

export const AddOnLabelText = styled.span`
  font-weight: 400;
`;

export const AddOnLabelName = styled.span`
  &&& {
    font-weight: 700;
  }
`;

export const AddOnOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .MuiCheckbox-root:not(.Mui-disabled):not(.Mui-checked) {
    color: ${({ theme }) => theme.neutral500};
  }
`;

export const ModalDivider = styled.div`
  border-top: 1px solid #e0e0e0;
  margin-top: 16px;
`;

export const AddOnModalNotice = styled(NewReqRequiredMessage)`
  margin-bottom: 0;
`;
